import React from 'react';
import StyledComponents from './styles';

const {
  Card,
  TitleBox,
  IconBox,
  Details
} = StyledComponents;

export default function ReassigningProjectCard({ requestData, translations, show }) {
  // translations = projectStatusTracker.statusScreen.currentStatus.reassigningProject
  const {
    title,
    descriptionOne,
    descriptionTwo
  } = translations;

  if(!show) return null;
  return (
    <Card>
      <TitleBox>
        <IconBox>
          <i className="far fa-user-check" />
        </IconBox>
        <h2>{title}</h2>
      </TitleBox>
      <Details>
        <p>
          {descriptionOne} {requestData.WorkerType} {descriptionTwo}
        </p>
      </Details>
    </Card>
  )
}